<template lang="pug">
  div#app
    RegistrationUrlTracker
    index
</template>

<script>
import RegistrationUrlTracker from "@chronos/frontend-base/src/components/registrationurltracker/RegistrationUrlTracker.vue";

import index from "./components/index";

export default {
  name: "App",
  components: {
    index,
    RegistrationUrlTracker,
  },
};
</script>

<style lang="scss">
@import "@/assets/style/index.scss";
</style>